@if ((componentData$ | async); as data) {
  @if (data.uid === 'SGREFAQNavComponent') {
    <app-faq-navigation [componentData]="(data$ | async)"></app-faq-navigation>
  }
  @if (data.uid === 'UserAccountComponent') {
    <app-header-sign-in></app-header-sign-in>
  }
}